import { EnvironmentVariable } from '../constants/env'
import { getEnvVar } from './env'

export const getMfeBundleUrl = (port: string, appName: string) => {
  const script = `${appName}-feature-app.federated.js`
  if (process.env.NODE_ENV === 'development') {
    return `http://${window.location.hostname}:${port}/${script}`
  } else {
    return `${getEnvVar(EnvironmentVariable.PUBLIC_PATH)}/container/mfes/${script}`
  }
}
